import { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import PageNotFound from './PageNotFound';
import { useUser } from '../hooks/useUser';
import { routerMap } from '../utils/routerMap';
import { MainRoutes } from './MainRoutes';

export default function AppRoutes(): ReactElement {
  const [, signOut] = useUser();

  return (
    <Routes>
      {MainRoutes(signOut).map(routerMap)}
      <Route path={'*'} element={<PageNotFound />} />
    </Routes>
  );
}
